import { Delete } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useTheme
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, { forwardRef, memo, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
 
const BillingTable = forwardRef((props, ref) => {
  const theme = useTheme();
  const classes = useStyle();
  const outletId = localStorage.getItem("outlet_id")
  const {outletType, setOutletType,salesMargin,data, setData,code, setCode, setPostData , postData , docName} = props
  const [itemData, setItemData] = useState(null)
  const [qty, setQty] = useState('')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100); // Set the rows per page
  const pageCount = Math.ceil(data.length / rowsPerPage);

  const dispatch = useDispatch()
  const [rateData, setRateData] = useState({
    mrp : '',
    disc :'',
    rate :'',
    gst : '',
    prod_id : '',
    pro_name:''
    
  })

  const [editingIndex, setEditingIndex] = useState(null);
  const [endCode, setEndCode] = useState('')
  const [endCode1, setEndCode1] = useState('')
  const [codeNo, setCodeNo] = useState('')
  const [filteredData, setFilteredData] = useState(data);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [startCode, setStartCode] = useState('');
  const startCodeRef = useRef(null);
  const endCodeRef = useRef(null);

  const codeRef = useRef(null)
  const qtyRef = useRef(null)
  const tableRef = useRef(null);
  const updatedRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
    qty : useRef(null),
    pro_name: useRef(null)
  }
  console.log(outletType,"datadatadatasalesMargin")

  const clearScanInputsAndFocus = () => {
    setCode('');
    setQty('');
    setEndCode('');
    setItemData(null);
    setRateData({ mrp: "", rate: "", gst: "", disc: "", prod_id: "", pro_name: "" });
    codeRef.current?.focus();
  };

  const getBarcodeCheckErrorMessage = (responseData, { isSingleBarcode = false } = {}) => {
    const status = String(responseData?.available_status || '').trim().toUpperCase();
    const apiMessage = String(
      responseData?.message ||
      responseData?.error_message ||
      responseData?.status_message ||
      ''
    ).trim();

    const isBilledIndicator = (value) => {
      const lower = String(value || '').toLowerCase();
      return (
        lower.includes('bill') ||
        lower.includes('sold') ||
        lower.includes('transfer') ||
        lower.includes('issued')
      );
    };

    if (apiMessage && isBilledIndicator(apiMessage)) {
      return apiMessage;
    }

    if (
      responseData?.is_billed === true ||
      responseData?.is_billed === 1 ||
      responseData?.is_sold === true ||
      responseData?.is_sold === 1 ||
      responseData?.s_us_status === 2
    ) {
      return 'Item is already billed';
    }

    if (status && status !== 'AVAILABLE' && status !== 'NOT AVAILABLE' && isBilledIndicator(status)) {
      return 'Item is already billed';
    }

    if (apiMessage) {
      return apiMessage;
    }

    if (isSingleBarcode && status === 'NOT AVAILABLE') {
      return 'Item is already billed';
    }

    return 'Quantity exceeds available stock';
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
   };
   
   const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
   };
   
     const rows = useMemo(() => {
       return data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
     }, [data, page, rowsPerPage]);
 
 const handleCodeKeyPress = (e) => {
    if (e.key === "Enter" && code !== '') {
      let arr = [...data];
      setQty('1');
      let isDuplicate = false;
      if (data.length > 0) {
        let ogCode = parseInt(code.toString().slice(-6));
        for (let i = 0; i < data.length; i++) {
          let startCode = parseInt(data[i].barcode?.toString().slice(-6));
          let endCode = parseInt(data[i].barcode_to.slice(-6));
          if (ogCode >= startCode && ogCode <= endCode) {
            dispatch(setSnackbar(true, 'error', 'Barcode already exist!'));
            isDuplicate = true;
            break;
          }
        }
        if (isDuplicate) return;
      }
      axios.get(`/v1/itemdetails/barcode/issue/${code}`).then(res => {
        // Calculate total including gst from existing items
        const currentTotal = data.reduce(
          (sum, item) => sum + Number(item.totalAmt || 0) + Number(item.gstAmt || 0),
          0
        );
        const qtyNum = 1;
        const rate = parseFloat(res.data.sale_rate || 0);
        const discPercent = parseFloat(res.data.discount || 0);
        const gstPercent = parseFloat(res.data.gst || 0);
        const priceAfterDisc = rate * (1 - discPercent / 100);
        const gstAmt = priceAfterDisc * (gstPercent / 100) * qtyNum;
        const newItemTotalWithGst = (priceAfterDisc * qtyNum) + gstAmt;
        const projectedTotal = currentTotal + newItemTotalWithGst;

        const EPSILON = 0.01; 
        if (projectedTotal - 49000 > EPSILON) {
        dispatch(setSnackbar(true, "error", "Total purchase value cannot exceed ₹49,000"));
        const removeIndex = arr.findIndex(item =>
            item.code === code
             );
             if (removeIndex !== -1) {
             arr.splice(removeIndex, 1);
            setData(arr);
           }
         setCode('');
         setQty('');
         return;
         }
        setItemData(res.data);
        setEndCode(code);
        const rateObj = {
          mrp: res.data.mrp,
          rate: res.data.sale_rate,
          gst: res.data.gst,
          disc: res.data.discount,
          prod_id: res.data.prod_id,
          mode: res.data.mode,
          ...res.data
        };
        setRateData(rateObj);
        qtyRef.current.focus();
        handleCheckQty(code, code, rateObj);
      }).catch(err => {
        dispatch(setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || "Error fetching barcode"));
      });
    }
  };
  const resetInputs = () => {
    setQty('');
    setItemData(null);
    setRateData({ mrp: "", rate: "", gst: "", disc: "", prod_id: "", pro_name: "" });
    codeRef.current?.focus();
  };
  console.log(rateData,"gstcheck");
   const handleAddRow = () => {
    const newItem = {
      code: rateData.prod_id,
      barcode_to: rateData.barcode_to,
      pro_name: itemData?.pro_name,
      mrp1: rateData.mrp,
      gst1: rateData.gst,
      rate1: rateData.rate,
      disc1: rateData.disc,
      qty: parseInt(qty, 10),
      gstAmt: parseFloat((parseInt(qty, 10) * rateData.gst) / 100).toFixed(0),
      totalAmt: parseFloat(parseInt(qty, 10) * rateData.rate).toFixed(2),
    };

    const newData = [...data, newItem];
    const uniqueData = newData.reduce((acc, current) => {
      const existing = acc.find(item => item.code === current.code && item.barcode_to === current.barcode_to);
      if (!existing) {
        return acc.concat(current);
      } else {
        existing.qty += current.qty;
        existing.totalAmt = (existing.qty * rateData.rate).toFixed(0);
        existing.gstAmt = (existing.qty * rateData.gst / 100).toFixed(0);
        return acc;
      }
    }, []);

    // Calculate total including gst
    const totalPurchaseValue = uniqueData.reduce(
      (sum, item) => sum + Number(item.totalAmt || 0) + Number(item.gstAmt || 0),
      0
    );

    if (totalPurchaseValue > 49000) {
      dispatch(setSnackbar(true, "error", "Total purchase value cannot exceed ₹49,000"));
      // Remove offending barcode permanently
      const offendingBarcode = newItem.code;
      const filtered = uniqueData.filter(item => item.code !== offendingBarcode);
      setData(filtered);
      setQty('');
      return;
    }
    setData(uniqueData);
    resetInputs();
    setCode('');
    setEndCode('');
  };
  const handleCheckQty = (startCode, newEndCode, rateObj) => {
    const discountedMrp = rateObj.mrp * (1 - rateObj.disc1 / 100);
    const gstAmt = Math.round(discountedMrp * (rateObj.gst / 100) * qty * 100) / 100;
    axios.post(`/v1/barcode/check`, { starting_barcode: startCode, ending_barcode: newEndCode, prod_id: rateObj.prod_id, outlet_id: outletId })
      .then((res) => {
        if (res.data.available_status === "AVAILABLE") {
          const objData = {
            code: startCode,
            barcode_to: newEndCode,
            qty: qty === "" ? 1 : qty,
            prod_id: rateObj.prod_id,
            mrp1: rateObj.mrp,
            rate1: rateObj.rate,
            gst1: rateObj.gst,
            disc1: rateObj.disc,
            gst_amt: gstAmt,
            pro_name: rateObj.pro_name,
            gstAmt: Number(((rateObj.rate || 0) * (rateObj.gst || 0) / 100).toFixed(2)),
            cessAmt: parseFloat((rateObj.mrp - rateObj.mrp * rateObj.disc / 100) * (rateObj.cess / 100) * (qty === "" ? 1 : qty)).toFixed(0),
            totalAmt: parseFloat((rateObj.rate - rateObj.rate * rateObj.disc / 100) * (qty === "" ? 1 : qty)).toFixed(2),
            ...rateObj
          }
          getTempPostData(objData, qty === "" ? 1 : qty)
          const existingItemIndex = data.findIndex((item) => item.code === objData.code && (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1));
          const arr = [...data]
          if (existingItemIndex !== -1) {
            arr[existingItemIndex].gstAmt = (parseFloat(arr[existingItemIndex].rate1)) * (parseFloat(arr[existingItemIndex].gst1 / 100)) * parseFloat(arr[existingItemIndex].qty);
            arr[existingItemIndex].cessAmt = (parseFloat(arr[existingItemIndex].rate1) - parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].cess / 100)) * parseFloat(arr[existingItemIndex].qty);
            arr[existingItemIndex].totalAmt = (parseFloat(arr[existingItemIndex].rate1) - parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * parseFloat(arr[existingItemIndex].qty);
            setData(arr);
          } else {
            setData(arr);
          }
          clearScanInputsAndFocus();
        } else {
          clearScanInputsAndFocus();
          dispatch(setSnackbar(
            true,
            "error",
            getBarcodeCheckErrorMessage(res.data, { isSingleBarcode: startCode === newEndCode })
          ));
        }
      })
      .catch((err) => {
        clearScanInputsAndFocus();
        dispatch(setSnackbar(
          true,
          "error",
          err.response?.data?.errors?.[0]?.message ||
          err.response?.data?.message ||
          "Error checking barcode"
        ));
      });
     };
     
   const handleDeleteRow=(e, i)=>{
    const updateArr = [...data]
    updateArr.splice(i,1)
    setData(updateArr)
    console.log(e, i)
    deleteTempData(e.id)
  }

  const handleQtyChange = (e) =>{
    const value = e.target.value.replace(/\D/g, '')
      setQty(value)
      
      console.log(e.target.value)
  }
  const handleCodeChange = (e) =>{
    setCode(e.target.value.toUpperCase());
  }

  const getItemCode = (id) =>{
    axios.get(`/v1/itemdetails/barcode/issue/${id}`)
    .then(res=>{
      setItemData(res.data)
      setEndCode(id)
      const rateObj = {
        mrp: res.data.mrp,
         rate: res.data.sale_rate, 
         gst : res.data.gst, disc : res.data.discount, prod_id: res.data.prod_id,mode: res.data.mode, ...res.data
      }

      console.log(rateObj)
      qtyRef.current.focus()
      handleCheckQty(code , code, rateObj)
    })
    .catch(err=>{
      console.log(err.response.data.errors[0].message)
      dispatch(setSnackbar(true , "error" ,err.response.data.errors[0].message ))
    })

  }
//   const getTempPostData = (value, q) => {
//     setLoading(true);
//     console.log(value)
//     const prefix = endCode.toString().slice(0,4)
//     const suffix = endCode.toString().slice(4)
//     console.log('prefix :',prefix,'suffix :', suffix)
//     const newEndCode = prefix + (parseFloat(suffix) + parseFloat(qty) - 1).toString().padStart(8, '0');
//     console.log(code,newEndCode)
// const mrp = parseFloat(value.mrp || 0);
// const marginPercent = parseFloat(salesMargin || 0) / 100;
// const discountPercent = parseFloat(value.disc1 || 0) / 100;
// const discountedMrp = value.sale_rate * (1 - value.disc1 / 100);
// // const gstAmt = Math.round(discountedMrp * (value.gst / 100) * q * 100) / 100;
// const gstAmt = (saleRate * gstPercent / 100) * quantity;
// console.log(discountedMrp,"discountedMrp");


// // const gstAmt = parseFloat(discountedMrp * (value.gst / 100) * q).toFixed(0);
// console.log(gstAmt,value.totalAmt,"gstAmts");

//     const tempSaveData = {
//       docno: docName,
//       docdate: moment(value.created_at).format("YYYY-MM-DD"),
//       outlet_id: outletId,
//       mode: "",
//       address: "",
//       gst_in: value.gst_per, //Theva illa
//       barcode_from: value.barcode || value.barcode_from,
//       barcode_to: value.barcode_to,
//       prod_id: value.prod_id,
//       mrp: value.mrp,
//       dis_per: value.disc1,
//       gst_per: value.gst || value.gst_per,
//       // gst_amt: value.gstAmt,
//       gstAmt:value.gstAmt || value.gst_amt,
//       gstAmt:gstAmt || value.gst_amt,
//       sale_rate:value.sale_rate,
//       qty: q ||value.qty,
//       gst_amt :gstAmt ,
//       amount: value.totalAmt
//     }
//     console.log(tempSaveData,"tempSaveData")
//     axios.post(`/v1/issue_transfer_temp` , tempSaveData)
//     .then((res) => {
//       console.log(res)
//       getTempData()
//     })
//     .catch((err) => {
//       console.log(err)
//       dispatch(setSnackbar(true , "error" ,err.response.data.errors[0].message ))

//     })
//     .finally(()=>{
//       setLoading(false);
//     })
//   }
const getTempPostData = (value, q) => {
  setLoading(true);
  console.log(value)
  const prefix = endCode.toString().slice(0,4)
  const suffix = endCode.toString().slice(4)
  console.log('prefix :',prefix,'suffix :', suffix)
  const newEndCode = prefix + (parseFloat(suffix) + parseFloat(qty) - 1).toString().padStart(8, '0');
  console.log(code,newEndCode)
  // FIXED: Exact formula - gstAmt = (sale_rate × gst_per / 100) × qty
  const saleRate = parseFloat(value.sale_rate || 0);
  const gstPercent = parseFloat(value.gst_per || value.gst || 0);
  const quantity = parseFloat(q || value.qty || 0);
  const gstAmt = (saleRate * gstPercent / 100) * quantity;
  console.log(saleRate, gstPercent, quantity, gstAmt,"gstAmt calculation");
  const tempSaveData = {
    docno: docName,
    docdate: moment(value.created_at).format("YYYY-MM-DD"),
    outlet_id: outletId,
    mode: "",
    address: "",
    gst_in: value.gst_per,
    barcode_from: value.barcode || value.barcode_from,
    barcode_to: value.barcode_to,
    prod_id: value.prod_id,
    mrp: value.mrp,
    dis_per: value.disc1,
    gst_per: value.gst || value.gst_per,
    sale_rate: value.sale_rate,
    qty: q || value.qty,
    // FIXED: Use the calculated gstAmt with exact formula
    gst_amt: gstAmt,
    amount: value.totalAmt
  }
  console.log(tempSaveData,"tempSaveData")
  axios.post(`/v1/issue_transfer_temp`, tempSaveData)
    .then((res) => {
      console.log(res)
      getTempData()
    })
    .catch((err) => {
      console.log(err)
      dispatch(setSnackbar(true, "error", err.response.data.errors[0].message))
    })
    .finally(()=>{
      setLoading(false);
    })
}

const getTempData = () => {
  setLoading(true);
  const requestPayload = {
    docno: docName,
    outlet_id: outletId,
  };

  console.log("Sending request with payload:", requestPayload);

  axios
    .post(`/v1/issue_transfer_temp_get`, requestPayload)
    .then((res) => {
      console.log("API Response:", res);

      // Check if the response contains the expected structure
      if (!res.data || !Array.isArray(res.data.data)) {
        console.error("Unexpected response format:", res.data);
        return;
      }

      // Extract totalQty from the response object
      const totalQty = res.data.totalQty ? parseFloat(res.data.totalQty) : 0;
      console.log("Total Quantity:", totalQty);

      // Extract and process the data from the 'data' array
      const filteredData = res.data.data.filter((item) => item.totalQty === undefined);
      console.log("Filtered Data:", filteredData);
      // const adjustedRate = outletType !== 'OWN' ? res.data.sale_rate + salesMargin : res.data.sale_rate;

      const processedData = filteredData.map((val) => ({
        id: val.id,
        code: val.barcode_from,
        barcode_to: val.barcode_to,
        pro_name: val.pro_name,
        mrp1: parseFloat(val.mrp || 0).toFixed(0),
        gst1: parseFloat(val.gst_per || 0).toFixed(0),
        rate1: parseFloat(val.sale_rate || 0).toFixed(2),
        disc1: parseFloat(val.dis_per || 0).toFixed(0),
        qty: parseFloat(val.qty || 0).toFixed(0),
        gstAmt: parseFloat(val.gst_amt || 0).toFixed(2),
        totalAmt: parseFloat(val.amount || 0).toFixed(2),
        ...val,
      }));

      // Set the processed data and totalQty to state or use as needed
      setData(processedData);
      setTotalQuantity(totalQty);

      console.log("Processed Data:", processedData);
    })
    .catch((err) => {
      setData([])
      console.error("Error fetching data:", err.message || err);
    })
    .finally(()=>{
      setLoading(false);
    })
};


  function deleteTempData(id){
    const postData = {
      docno : docName,
      outlet_id : outletId,
      id : id
    }
    console.log(id)
    axios.post(`v1/issue_transfer_temp/delete`, postData)
    .then(res=>{
      console.log(res)
    })
    .catch(err=> console.log(err))
  }
  useEffect(() => {
    if(docName != ""){
      getTempData()
    }
    // getTempData()
  },[docName,])
  console.log(docName,"docName");
  
  const clearNew = () =>{
    setCode('')
    setEndCode("")
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" , prod_id: "", pro_name: "" }))
    codeRef.current.focus()
  }

const handleEditChange = (e, name) => {
  const arr = [...data]; // Create a shallow copy of the data array
  const value = e.target.value.replace(/\D/g, ''); // Allow only numeric input

  if (name === 'qty') {
    // Update the quantity in the editingIndex row
    arr[editingIndex].qty = Number(value);

    // Ensure codeNo is updated correctly
    setCodeNo(arr[editingIndex].code);

    // Calculate discount amount
    const discountAmount = arr[editingIndex].mrp * (arr[editingIndex].disc1 / 100);
    const priceAfterDiscount = arr[editingIndex].mrp - discountAmount;

    // Calculate total amount before GST
    const totalAmount = priceAfterDiscount * arr[editingIndex].qty;

    // Calculate GST amount
    const gstAmount = totalAmount * (arr[editingIndex].gst1 / 100);

    // Calculate total amount including GST
    const totalWithGST = totalAmount + gstAmount;

    // Update the item with the calculated values
    arr[editingIndex] = {
      ...arr[editingIndex],
      gstAmt: gstAmount.toFixed(0),
      totalAmt: totalAmount.toFixed(0),
      totalWithGST: totalWithGST.toFixed(0),
    };

    setData(arr); // Update the state with the modified array
  }

  console.log("Updated Quantity:", arr[editingIndex].qty);
  console.log("Total Amount Before GST:", arr[editingIndex].totalAmt);
  console.log("GST Amount:", arr[editingIndex].gstAmt);
  console.log("Total Amount Including GST:", arr[editingIndex].totalWithGST);
};

 function getSelectedRow(e){
  setEditingIndex(e)
 } 

function handleUpdatedKey(e) {
  if (e.key === 'Enter' && e.target.value !== '' && e.target.value != 0) {
    const arr = [...data];
    console.log(data, "dattaa");
    const nextRef = e.target.name;
    const prefix = codeNo.toString().slice(0, 4);
    const suffix = codeNo.toString().slice(4);
    console.log('prefix :', prefix, 'suffix :', suffix);
    const newEndCode = prefix + (parseFloat(suffix) + parseFloat(arr[editingIndex].qty) - 1).toString().padStart(8, '0');
    console.log(codeNo, newEndCode,"codeeeecheck");

    //Check if the barcode range already exists in the table list
    const isBarcodeRangeExists = arr.some(item => 
      
      item.barcode_to === newEndCode || 
      (codeNo >= item.starting_barcode && newEndCode <= item.ending_barcode) 
    );

    if (isBarcodeRangeExists) {
      dispatch(setSnackbar(true, "error", "Barcode range already available. Please remove it."));
      return; // Exit the function without making the API call
    }

    arr[editingIndex].barcode_to = newEndCode;
    console.log(arr[editingIndex]);

    axios.post(`/v1/barcode/check`, {
      starting_barcode: codeNo,
      ending_barcode: newEndCode,
      prod_id: arr[editingIndex].prod_id,
      outlet_id: outletId,
    })
      .then((res) => {
        if (res.data.available_status === "NOT AVAILABLE") {
          dispatch(setSnackbar(
            true,
            "error",
            getBarcodeCheckErrorMessage(res.data, { isSingleBarcode: false })
          ));
          setData([]);
          arr[editingIndex].qty = 0;
          arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1) * (arr[editingIndex].gst1 / 100) * 0).toFixed(0);
          arr[editingIndex].totalAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * 0).toFixed(0);
          arr[editingIndex].cessAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (arr[editingIndex].cess / 100) * 0).toFixed(0);
          setData(arr);
        } else if (res.data.available_status === "AVAILABLE") {
          setData([]);
          checkUpdatedRef(nextRef);
          // deleteTempData(arr[editingIndex].prod_id)
          const objData = {
            code: codeNo,
            barcode: codeNo,
            barcode_to: newEndCode,
            qty: arr[editingIndex].qty,
            prod_id: arr[editingIndex].prod_id,
            mrp: arr[editingIndex].mrp,
            rate: arr[editingIndex].rate,
            gst: arr[editingIndex].gst,
            gst1: arr[editingIndex].gst_in,
            disc1: arr[editingIndex].disc,
            gstAmt: parseFloat((arr[editingIndex].mrp) * (arr[editingIndex].gst_in / 100) * arr[editingIndex].qty).toFixed(0),
            totalAmt: parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * arr[editingIndex].qty).toFixed(0),
            ...arr[editingIndex],
          };
          // saveUpdatedData(objData);
          getTempPostData(
            objData, arr[editingIndex].qty,
            objData, arr[editingIndex].gstAmt,
          
          );
          // getTempData();
          console.log(objData, "objData En Varala");
        }
        setData(arr);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
      });
  }
}


 function checkUpdatedRef(value){
if(value==='mrp'){
updatedRef.gst.current.focus()
}
else if(value==='gst'){  
updatedRef.rate.current.focus()
}
else if(value==='rate'){  
  updatedRef.disc.current.focus()
  }
  else if(value==='disc'){  
    updatedRef.qty.current.focus()
    }
  else
   if(value==='qty'){
addToData()
  }
 }

 function addToData(){
codeRef.current.focus()
 }
 useImperativeHandle(ref, () => ({
  focusCodeInput: () => {
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
    codeRef.current.focus()
  }
}));

useEffect(() => {
  if (data.length > 0) {
    let arr = [];
    data.map((val) => {
      const obj = {
        docdate: moment().format("YYYY/MM/DD"), // String (date format)
        prodid: Number(val.prod_id), // Number
        // prodid: Number(val.id), // Number
        dis_per: Number(val.disc1), // Number
        dis_amt: Number(
          parseFloat(
            (val.rate1 - (val.rate1 * (100 - val.disc1)) / 100) * val.qty
          ).toFixed(0)
        ), // Number
        mrp: Number(val.mrp1), // Number
        rate: Number(val.rate1), // Number
        qty: Number(val.qty), // Number
        gst_per: Number(val.gst1), // Number
        gst_amt: Number(val.gstAmt), // Number
        cess_per: Number(val.cess || 0), // Number
        cess_amt: Number(val.cessAmt || 0), // Number
        company_id: 1, // Number
        barcode: val.barcode_from, // String
        barcode_to: val.barcode_to, // String
        head_id: Number(val.head_id), // Number
        type_id: Number(val.type), // Number
        subcat_id: Number(val.sub_cat), // Number
        cat_id: Number(val.cat_id), // Number
        uom_id: Number(val.uom), // Number
        purchase_rate: Number(val.pur_rate)
      };
      arr.push(obj);
    });
    setPostData((prevState) => ({ ...prevState, sales_details: arr }));
  }
}, [data,]);

  // Calculate the rows to display based on the current page and rowsPerPage
  const displayedRows = data.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

 const handleCodeKeyPress1 = async (e, nextFieldRef) => {
    if ((e.key === "Enter" || e.key === 'Tab')) {
    // if ((e.key === "Enter" || e.key === 'Tab') && startCode !== "" && endCode1 !== "") {
      e.preventDefault();
       // Move focus to "End Barcode" field if the reference exists
    if (nextFieldRef && nextFieldRef.current) {
      nextFieldRef.current.focus();
    }

    // Only run the barcode range validation logic if both fields have values
    if (startCode === "" || endCode1 === "") {
      return; // Skip further logic to avoid errors
    }
      let start = parseInt(startCode, 10);
      let end = parseInt(endCode1, 10);
      if (isNaN(start) || isNaN(end)) return;
      if (start > end) {
        dispatch(setSnackbar(true, "error", "Start Code cannot be greater than End Code!"));
        return;
      }
      let qtyRange = end - start + 1;

      try {
        const res = await axios.get(`/v1/itemdetails/barcode/issue/${startCode}`);
        let itemData = res.data;
        setItemData(itemData);

        if (!itemData) {
          dispatch(setSnackbar(true, "error", "Item not found!"));
          return;
        }
        let rateObj = {
          mrp: itemData.mrp,
          rate: itemData.sale_rate,
          gst: itemData.gst,
          disc: itemData.discount,
          prod_id: itemData.prod_id,
          ...itemData
        };

        // Calculate new entry total including GST
        const baseRate = rateObj.rate * (1 - rateObj.disc / 100);
        const newEntryAmount = baseRate * qtyRange;
        const newEntryGST = baseRate * (rateObj.gst / 100) * qtyRange;
        const newEntryTotalWithGST = newEntryAmount + newEntryGST;

        // Calculate current total including GST from existing data
        const currentTotal = data.reduce(
          (sum, item) => sum + Number(item.totalAmt || 0) + Number(item.gstAmt || 0),
          0
        );

        const projectedTotal = currentTotal + newEntryTotalWithGST;

        if (projectedTotal > 49000) {
          dispatch(setSnackbar(true, "error", "Total purchase value cannot exceed ₹49,000"));
          // Remove this barcode range permanently from table
          const filtered = data.filter(item =>
            !(parseInt(item.code) === start && parseInt(item.barcode_to) === end)
          );
          setData(filtered);
          setStartCode("");
          setEndCode1("");
          return;
        }
        handleCheckQty1(startCode, endCode1, rateObj, qtyRange);
      } catch (error) {
        dispatch(setSnackbar(true, "error", error.response?.data?.errors[0]?.message || "Error fetching item details"));
      }
    }
  };
   useEffect(() => {
    if (docName !== "") {
      getTempData()
    }
  }, [docName]);
const handleCheckQty1 = (startCode, endCode1, rateObj, qty) => {
  axios
    .post(`/v1/barcode/check`, {
      starting_barcode: startCode,
      ending_barcode: endCode1,
      prod_id: rateObj.prod_id,
      outlet_id: outletId
    })
    .then((res) => {
      if (res.data.available_status === "AVAILABLE") {
        let gstAmt = ((rateObj.rate - (rateObj.rate * rateObj.disc) / 100) * (rateObj.gst / 100) * qty).toFixed(2);
        let newEntry = {
          barcode_from: startCode,
          // barcode_from:startCode,
          barcode_to: endCode1,
          pro_name: rateObj.pro_name || "New Product",
          mrp: rateObj.mrp,
          gst_per: rateObj.gst,
      
          rate1: rateObj.rate,
          disc1: rateObj.disc,
          prod_id:rateObj.prod_id,
          sale_rate:rateObj.sale_rate,
          qty: qty,
          gstAmt: Number(gstAmt),
          totalAmt: ((rateObj.rate - (rateObj.rate * rateObj.disc / 100)) * qty).toFixed(0)
        };

        // setData((prevData) => [...prevData, newEntry]);
        setStartCode("");
        setEndCode1("");
        getTempPostData(newEntry)
        
      } else {
        setStartCode("");
        setEndCode1("");
        setItemData(null);
        setRateData({ mrp: "", rate: "", gst: "", disc: "", prod_id: "", pro_name: "" });
        dispatch(setSnackbar(
          true,
          "error",
          getBarcodeCheckErrorMessage(res.data, { isSingleBarcode: startCode === endCode1 })
        ));
        codeRef.current?.focus();
      }
    })
    .catch((err) => {
      setStartCode("");
      setEndCode1("");
      setItemData(null);
      setRateData({ mrp: "", rate: "", gst: "", disc: "", prod_id: "", pro_name: "" });
      codeRef.current?.focus();
      dispatch(setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || err.response?.data?.message || "Error checking quantity"));
    });
};
const handleStartCodeChange = (e) => {
  // setStartCode(e.target.value.replace(/\D/g, ""));
  setStartCode(e.target.value.toUpperCase());
};

const handleEndCodeChange = (e) => {
  // setEndCode1(e.target.value.replace(/\D/g, ""));
  setEndCode1(e.target.value.toUpperCase());

};
console.log(endCode , "End Code")
console.log(displayedRows , "Start code")
console.log(postData.partycode)
return (
  <Box position="relative" width="100%">

    <Grid className="w-full h-full">
      
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
   <Box sx={{ mr: 2 }}>
      {/* Barcode Field */}
      <Box       sx={{
          p: 2,
          mb: 2,
          backgroundColor: '#83A2FF',
          borderRadius: 2,
        }}>
        <Typography variant="body1" fontSize={17} sx={{ mr: 1,color:"white", }}>
          Barcode
        </Typography>
        <TextField 
              
              // label="Barcode"
              placeholder="enter barcode"
               inputRef={codeRef}
               size='small'
               value={code}
               onChange={handleCodeChange}
               onKeyPress={handleCodeKeyPress}
               sx={{ mr: 2 ,backgroundColor:"white"}}
             
              />
      </Box>  
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, p: 2,
          mb: 2,
          backgroundColor: 'primary.light',
          borderRadius: 2, }}>
        {/* From Barcode Field */}
        <Box >
        <Typography variant="body1" fontSize={17} sx={{ mr: 1 ,color:"white"}}>
          From Barcode
        </Typography>
        <TextField
  // label="Start Barcode"
  placeholder="Enter start barcode"
  inputRef={startCodeRef}
  size="small"
  value={startCode}
  onChange={handleStartCodeChange}
  onKeyDown={(e) => handleCodeKeyPress1(e, endCodeRef)}
  // onKeyDown={handleCodeKeyPress1}
  sx={{ mr: 2,backgroundColor:"white" }}
/>
      </Box>

      {/* End Barcode Field */}
      <Box >
        <Typography variant="body1" fontSize={17} sx={{ mr: 1,color:"white" }}>
          End Barcode
        </Typography>
        <TextField
  // label="End Barcode"
  placeholder="Enter end barcode"
  inputRef={endCodeRef}
  size="small"
  value={endCode1}
  onChange={handleEndCodeChange}
  // onKeyDown={handleCodeKeyPress1}
  onKeyDown={(e) => handleCodeKeyPress1(e, null)}
  sx={{backgroundColor:"white",}}

/>
      </Box>
    </Box>
    </Box>
        {/* <Typography textAlign="right" variant="h5"  sx={{ fontWeight: 600 }}>Total Quantity : {totalQuantity}</Typography> */}

      <TableContainer className={classes.tblRoot} sx={{height:"500px !important" , overflow:"auto"}} ref={tableRef}>
        <Table stickyHeader  className={classes.table}>
          <TableHead className={classes.tblHeader}>
            <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
              <TableCell className={classes.tblCell} sx={{minWidth:"160px"}}>Start Code</TableCell>
              <TableCell className={classes.tblCell}>End Code</TableCell>
              <TableCell className={classes.tblCell}>Product Name</TableCell>
              <TableCell className={classes.tblCell}>MRP</TableCell>
              <TableCell className={classes.tblCell}>GST%</TableCell>
              <TableCell className={classes.tblCell}>Rate</TableCell>
              <TableCell className={classes.tblCell}>Dis%</TableCell>
              <TableCell className={classes.tblCell}>Qty</TableCell>
              <TableCell className={classes.tblCell}>GST</TableCell>
              {/* <TableCell className={classes.tblCell}>CESS</TableCell> */}
              <TableCell className={classes.tblCell}>Amount</TableCell>
              <TableCell className={classes.tblCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {displayedRows.map((val, idx) => (
            // {_.map(data, (val, idx) => (
               <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
               <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{idx + 1}</TableCell>
               
               <TableCell>{val.code}</TableCell>
              <TableCell>{val.barcode_to}</TableCell>
               <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{val.mrp1}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.gst1}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.rate1}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.disc1}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.qty}</TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.cessAmt).toFixed(0)}</TableCell> */}
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.totalAmt).toFixed(2)}</TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={() => handleDeleteRow(val, page * rowsPerPage + idx)}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={()=>handleDeleteRow(val, idx)}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell> */}
             </TableRow>
            ))}
            <TableRow className={classes.tablrow}>
              <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}></TableCell>
              {/* <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell> */}
            
              <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}>{code}</TableCell>
              <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}>{endCode}</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.pro_name}</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.mrp}</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.gst}</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.rate}</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.disc}</TableCell>
              <TableCell padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}>
              <TextField 
                size='small'
                inputRef={qtyRef}
                value={qty}
                onChange={handleQtyChange}
                onKeyPress={handleAddRow}
               />
              </TableCell>
              <TableCell className={classes.tblContentCell} sx={{width:100}}>{rateData.disc}</TableCell>
              <TableCell className={classes.tblContentCell} sx={{width:100}}>{itemData!==null && qty!=="" && parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(0) }</TableCell>
              <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={clearNew}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
            </TableRow>

          </TableBody>
          <TableFooter>
     <TableRow>
     <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={12} // Adjust based on your table's column count
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                pageCount={pageCount}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count }) => {
                  const pageCount = Math.ceil(count / rowsPerPage); // Calculate the page count
                  return `${page + 1}`; // Custom format with "< 1 >"
                }}
                sx={{
                  position: 'sticky',
                  bottom: 0,
                  backgroundColor: 'white',
                  zIndex: 1,
                }}
              />
     </TableRow>
     </TableFooter>
     </Table>     
    </TableContainer>
     
    </Grid>
     {loading && (
      <Box
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        position="absolute" 
        top={0} 
        left={0} 
        right={0} 
        bottom={0} 
        bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
        zIndex={1}
      >
        <CircularProgress size={50}/> {/* Material UI spinner */}
      </Box>
    )}
    </Box>
  );
});

export default memo(BillingTable);
